export default "__VITE_ASSET__Dgn$dQ$n__"